import RouteConstants from '@/features/router/RouteConstants';
import { useModalContext } from '@/hooks/useModalContext';
import type { WhatsappEditSelection } from '@/features/connectors/whatsapp';
import { useHistory } from 'react-router-dom';
import { WhatsappTemplate } from '../../../types/whatsappTemplates';
import { DeleteWhatsappTemplateModal } from '../DeleteWhatsappTemplateModal';

export type WhatsappTemplateEditLocationState = {
  editSelection: WhatsappEditSelection;
};

export const useWhatsappTemplateListActions = () => {
  const history = useHistory();
  const { openModal } = useModalContext();

  const handleCreate = () => {
    history.push(RouteConstants.createWhatsappTemplate);
  };

  const handleEdit = (template: Pick<WhatsappTemplate, 'id' | 'name' | 'language'>) => {
    const state: WhatsappTemplateEditLocationState = {
      editSelection: { id: template.id, name: template.name, language: template.language },
    };
    history.push(RouteConstants.whatsappTemplatesEditHub, state);
  };

  const handleRequestDelete = (template: WhatsappTemplate) => {
    openModal({
      renderContent: DeleteWhatsappTemplateModal,
      renderContentProps: {
        template: { id: template.id, name: template.name },
      },
      dismissable: true,
      fullWidth: false,
      fullHeight: false,
    });
  };

  const handleTemplatesHubEdit = (actionType: 'edit' | 'delete') => {
    if (actionType === 'edit') {
      history.push(RouteConstants.whatsappTemplatesEditHub);
    } else {
      history.push(RouteConstants.whatsappTemplatesDeleteHub);
    }
  };

  return {
    handleCreate,
    handleEdit,
    handleRequestDelete,
    handleTemplatesHubEdit,
  };
};
